<template>
  <div class="rightContent">
    <el-table stripe :data="tableData"
      @sort-change="sortChange" border style="width: 100%" height="100%" size="mini">
      <el-table-column type="index" :width="50" align="center"></el-table-column>
      <el-table-column prop="version" sortable="custom"
        label="版本号" max-width="110px" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.version" class="allowSkip" @click="clickAllowSkip(scope.row)">
            {{ scope.row.version }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="capacity" min-width="110px" sortable="custom"
        label="电池容量(mAh)" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.capacity">
            {{ scope.row.capacity }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>      
      <el-table-column prop="config" min-width="150px"
        label="曲线数据" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.config">
            {{ scope.row.config }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" sortable="custom" prop="enable"
        label="状态" align="center" width="130px">
        <template slot-scope="scope">              
          <span v-if="scope.row.enable">
            已启用
          </span>
          <span v-else>已禁用</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation"
        label="操作" align="center" width="130px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.enable" class="item" effect="dark"
            content="修改" placement="top" :open-delay="300">
            <i @click="editBattery($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <el-tooltip v-if="scope.row.enable" class="item" effect="dark"
            content="禁用" placement="top" :open-delay="300">
            <i @click="disableBattery($event, scope.row)" class="iconfont icon-jinyong"></i>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark"
            content="启用" placement="top" :open-delay="300">
            <i @click="enableBattery($event, scope.row)" class="iconfont icon-qiyong"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <myDialog ref="myDialog" :title="dialogTitle" :width=winWidth
      @submitData="saveForm" @dialogClose="loadData">
      <template slot="content">        
        <el-form ref="addForm" :model="addForm"
          :rules="dialogRules" :label-width="labelWidth">
         <el-form-item
            label="版本号" size="small" prop="version" class="inlineItem">
            <el-input v-model="addForm.version"
              placeholder="如：V1.0.1" clearable>
            </el-input>
          </el-form-item>
          <el-form-item
            label="电池容量" size="small" prop="capacity" class="inlineItem">
            <el-input :value="addForm.capacity" style="width:120px"
              placeholder="如：6500" @input="formatInputInt($event, 'addForm', 'capacity')" clearable>
            </el-input><span>（mAh）</span>
          </el-form-item>
          <el-form-item
            label="曲线参数" size="small" prop="config">
            <el-input v-model="addForm.config"
              placeholder="曲线参数" type="textarea" :rows="4">
            </el-input>
          </el-form-item>
        </el-form>        
      </template>
    </myDialog>
    <div class="commandPage">
    <el-dialog
      title="详情" :visible.sync="dialogVisible" width="800px"
      @close="dialogClose" :close-on-click-modal="false" :close-on-press-escape="false"
      top="50vh" class="myDialog detailDialog">
      <ul class="ulBox clearFloat">
        <li>
          <div class="left">版本号：</div>
          <div class="right">
            <span class="value" v-if="batteryDetailData.version">{{
              batteryDetailData.version
            }}</span>
            <span class="noValue" v-else>无</span>
          </div>
        </li>
        <li>
          <div class="left">电池容量：</div>
          <div class="right">
            <span class="value" v-if="batteryDetailData.capacity">
              {{batteryDetailData.capacity}}(mAh)
            </span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li class="blockLi">
          <div class="left">曲线数据：</div>
          <div class="right">
            <span class="value" v-if="batteryDetailData.config">{{
              batteryDetailData.config
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="closeDetail"
          >关闭</el-button>
      </div>
    </el-dialog>
    </div>
  </div>  
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import {
  apiProductBatteryAdd,
  apiProductBatteryUpdate,
  apiProductBatteryEnable,
  apiProductBatteryDisable,
  apiProductBatterySearch
} from "@/api/ProductionBattery.js";
export default {  
  components: {
    myDialog
  },
  props: {
    tabPaneValue: {
      type: String,
    }
  },
  data() {    
    return {
      pullDownData: {
        productList: []
      },
      orderBy: [],
      desc: undefined,
      addForm: {},      
      winWidth:"850px",
      productDetailData: {},
      dialogVisible: false,
      batteryDetailData: {},
      tableData: [],
      allCommands: [],      
      value:[],
      data:[],
      labelWidth: this.$store.state.labelWidth,      
      dialogTitle: "",
      dialogRules: {
        version: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
        ],
        capacity: [
          { required: true, message: "电池容量不能为空！", trigger: "blur" },
        ],
        config: [
          { required: true, message: "曲线参数不能为空！", trigger: "blur" },
          {
            min: 10,
            message: "长度在 10 个字符以上",
            trigger: "change",
          },
        ]
      },
    };
  },
  methods: {
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.loadData();
    },
    addBattery() {      
      this.addForm = {};
      this.dialogTitle = "新增电池曲线";
      this.winWidth="640px";
      this.$refs.myDialog.dialogVisible = true;
    },
    editBattery(e, row) {
      this.addForm = row;
      this.dialogTitle = "修改电池曲线";
      this.winWidth="640px";
      this.$refs.myDialog.dialogVisible = true;
    },
    enableBattery(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `启用电池曲线`,
        message: h("div", null, [
          h("span", null, `请输入版本号:【`),
          h("i", { style: "color: var(--themeColor)" }, row.version),
          h("span", null, `】以便确认启用`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.version) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        let res = await apiProductBatteryEnable({
          id: row.id,
        });
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.loadData();
        }
      });
    },
    disableBattery(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `禁用电池曲线`,
        message: h("div", null, [
          h("span", null, `请输入版本号:【`),
          h("i", { style: "color: var(--themeColor)" }, row.version),
          h("span", null, `】以便确认禁用`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.version) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {        
        let res = await apiProductBatteryDisable({
          id: row.id,
        });
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.loadData();
        }
      });
    },
    // 判断只能输入数字
    formatInputInt(value, formName, keyName) {
      this.$set(this[formName], keyName, this.$formatPositive(value));
    },
    dialogClose() {
      this.addForm = {};
    },
    closeDetail() {
      this.dialogVisible = false;
    },
    // 表格列命令名称点击
    async clickAllowSkip(row) {
      this.dialogVisible = true;
      this.batteryDetailData = row;
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    async loadData() {
      const res = await apiProductBatterySearch({
        productId: this.tabPaneValue,
        orderBy: this.orderBy,
        desc: this.desc,
      });
      if (res.code == 0) {
        this.tableData = res.data;
      }
    },
    saveForm() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          let res;
          if (this.dialogTitle=='修改电池曲线') {
            res = await apiProductBatteryUpdate({
              ...this.addForm,
              productId: this.tabPaneValue
            });
          } else if (this.dialogTitle=='新增电池曲线') {
            res = await apiProductBatteryAdd({
              ...this.addForm,
              productId: this.tabPaneValue
            });
          } else {
            this.$message({
              message: '不支持的操作【' + this.dialogTitle + '】',
              type: "error",
            });
            return false;
          }
          if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
   .rightContent >>> .el-transfer {
     margin: 10px;
   }
   .rightContent >>> .el-transfer-panel {
     width: 324px;
   }
   .rightContent >>> .el-transfer-panel__body {
     height: 420px;
   }
   .rightContent >>> .el-transfer-panel__list {
     height: 370px;
   }
   
   .detailTextArea >>> .el-textarea__inner {
    border: 0;
    cursor: auto;
    padding: 3px 0;
  }
</style>